import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivityFormModalComponent } from '@curbnturf/activity-component/src/lib/add-activity-form/activity-form-modal/activity-form-modal.component';
import { ActivityLocationFacade } from '@curbnturf/activity/src/lib/+state/activity.facade';
import { MapIconsComponent } from '@curbnturf/custom-svgs/src/lib/map-icons/map-icons.component';
import { ActivityLocation, Boondock, IActivityLocation, Listing } from '@curbnturf/entities';
import { PlatformService } from '@curbnturf/network/src/lib/platform/platform.service';
import { IonicModule, ModalController, NavController } from '@ionic/angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { BoondockAddModalComponent } from '../boondock-add-modal/boondock-add-modal.component';
import { ListingAddModalComponent } from '../listing-add-modal/listing-add-modal.component';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'curbnturf-add-listing-modal',
  templateUrl: './add-listing-modal.component.html',
  styleUrls: ['./add-listing-modal.component.scss'],
  standalone: true,
  imports: [FormsModule, IonicModule, MapIconsComponent, NgSelectModule, ReactiveFormsModule],
})
export class AddListingModalComponent {
  @Input() listings: Listing[] = [];
  @Input() boondocks: Boondock[] = [];
  @Input() pois: ActivityLocation[] = [];

  modal: HTMLIonModalElement;

  constructor(
    private activityLocationFacade: ActivityLocationFacade,
    private modalController: ModalController,
    private navController: NavController,
    private platformService: PlatformService,
  ) {}

  async host() {
    const modal = await this.modalController.create({
      component: ListingAddModalComponent,
      componentProps: {
        currentListings: this.listings,
      },
      cssClass: 'add-listing-modal',
    });

    await this.close();
    await modal.present();
  }

  async boondock() {
    const modal = await this.modalController.create({
      component: BoondockAddModalComponent,
      componentProps: {
        currentBoondocks: this.boondocks,
      },
      cssClass: 'add-listing-modal',
    });

    this.close();
    await modal.present();
  }

  async openPoiNewModal() {
    this.close();

    if (Capacitor.isNativePlatform() || this.platformService.isAppContext()) {
      await this.navController.navigateForward('activity/add');
    } else {
      const activity: IActivityLocation = {};

      this.activityLocationFacade.awaitActivity(activity);

      this.modal = await this.modalController.create({
        component: ActivityFormModalComponent,
      });

      await this.modal.present();
    }
  }

  async close() {
    await this.modalController.dismiss();
  }
}
